import { createAsyncThunk } from '@reduxjs/toolkit';
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from '../../utils/api';
import { setAlert } from '../alerts/actions';

export const list = createAsyncThunk(
  'contact-us/list',
  async (
    params = {
      page: 0,
      limit: 10,
      orderBy: null,
      orderDirection: null,
      filter: null,
      search: null,
    },
  ) => {
    try {
      const page = params.page ? params.page : 0;
      const limit = params.limit ? params.limit : 10;
      const res = await api.get(`/admin/contact-us`, { params });
      console.log(page, limit);
      return { ...res.data, page, limit };
    } catch (error) {
      console.log(error);
    }
  },
);

export const get = createAsyncThunk(
  'contact-us/get',
  async (id, { dispatch }) => {
    try {
      const res = await api.get(`/admin/contact-us/${id}`);
      return res.data;
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);
